import { NgModule } from '@angular/core';
import { SharedModule } from '../shared.module';

@NgModule({
  imports: [
    SharedModule
  ],
  providers: [
    ThemeCustomizerModule
  ],
  exports: [
    SharedModule
  ]
})
export class ThemeCustomizerModule {
}
